import React, { useEffect, useState } from 'react';
import { jt, t } from 'ttag';
import client from 'utils/client';
import { Loader } from '../reusable-components/misc';
import Engage from './components/Engage';
import Social from './components/Social';
import DisplayBox from './containers/DisplayBox';
import { brands, commonText } from './data';

function App() {
  const [commonTranslations, setCommonTranslations] = useState();
  const [loading, setLoading] = useState(false);
  const { phoneNumber, siteEmailAddress } = window.config;

  useEffect(() => {
    const fetchCommonTranslations = async () => {
      try {
        const res = await client.get(
          '/api/campaign/187/translation/?as_dict=true&strip_dashes=true'
        );
        setCommonTranslations(res.data.blocks);
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };
    fetchCommonTranslations();
  }, []);

  return (
    <div>
      <div>
        {commonText && <Engage data={commonText} />}
        {brands &&
          brands.map((brand, index) => {
            let sectionClass;
            if ((index + 1) % 2 === 0) {
              sectionClass = 'even-section';
            } else {
              sectionClass = 'odd-section';
            }
            return (
              <DisplayBox
                key={brand.id}
                brand={brand}
                sectionClass={sectionClass}
              />
            );
          })}
        <div className="story_telling">
          <h2>{t`Personalized football shirts and much more`}</h2>
          <p>
            {jt`Welcome to Unisport TeamSport. Unisport TeamSport was introduced in 2005, and has ever since been very successful. At Unisport TeamSport, we work together with professional clubs, amateur clubs, as well as small sports organizations. Since our launch, we have established cooperation with more than 36 clubs, ranging from top clubs to smaller sports organizations with just one team, highlighting the level of diversity in our cooperation’s. We know about the importance of having a community and creating a team spirit internally in a club. Team spirit, of course, starts with being good friends, but equally important is, to look like a unit who stands together - And this, is exactly what Unisport TeamSport is all about. Unisport TeamSports gives you the opportunity to design your own football team kit. We provide football team kits from some of the biggest brands, such as Nike adidas, Puma and Hummel. So if you want to create a strong unit while separating yourself from your competitors on the football pitch, you’ve come to the right place. Whether you choose Nike, adidas, Hummel or Puma, we can always guarantee high quality at low prices. Our football team kits are of course offered to both goalkeepers and outfield players, and consists of three parts; football shirt, shorts and of course football socks. Your personalized football shirt is just a few clicks away. All our football shirts are made of 100% polyester, and you can choose whatever color suits your club the best, so you and your teammates together can wear the color of your club, with pride. In addition, Unisport TeamSport also offer print of names and numbers on the back, your club logo on the chest, and even If your club have sponsor logos, then this is of course also an option to get on the shirt. Our football shorts and football socks, are also available in different colors. This gives you the opportunity to put together just the color combination you whish for. Whether you want a stylish and simple look, or if you want to work a more colorful combination, the choice is yours. Last but not least, we of course offer football team kits for both children and adults. Do you have any questions about range, size, prices etc., then you are always welcome to contact our Unisport TeamSport department at mail: ${siteEmailAddress} or by phone: ${phoneNumber}`}
          </p>
        </div>
      </div>
      {loading && <Loader />}
      {commonTranslations && <Social common={commonTranslations} />}
    </div>
  );
}

export default App;
